/**
 * Backend messages shown on the Books pages for the catalog (Authors, Book Management, Book Bundles, Warehouses), translated in the `serverBookCatalog` namespace
 * (locales/<lng>/serverBookCatalog.json). See serverMessages.js for how rules work; `t`, `label` and
 * `nested` here use this file's namespace, and `label` falls back to the shared labels in
 * `server`.
 *
 * The messages come from content-management-service on the backend's main branch: AuthorService,
 * BookService, BookBundleService, BookInventoryService and WarehouseService. Only
 * BookBundleController answers its errors as JSON today; the author, book and warehouse
 * controllers send the bare text, which the pages can't read and replace with their own message.
 * Their "not found" rules are here for when those controllers answer in JSON too, as the bundle
 * controller already does. Auth, "Validation failed" and "Internal server error" are shared rules
 * in serverMessages.js.
 */
// eslint-disable-next-line no-unused-vars
const rules = ({ t, label, nested, ANY }) => [
  // ---- api/v1/content/admin/authors: AuthorService (BookService when saving a book's authors)
  { match: /^Author not found: (?<id>\S+)$/, key: 'author.notFound' },

  // ---- api/v1/content/admin/books: BookService, BookBundleService (a bundle's items)
  { match: /^Book not found: (?<id>\S+)$/, key: 'book.notFound' },
  // ---- api/v1/content/admin/books/{id}/inventory: BookInventoryService
  { match: /^Book not found with id: (?<id>\S+)$/, key: 'book.notFoundWithId' },
  { match: /^Warehouse not found with id: (?<id>\S+)$/, key: 'warehouse.notFoundWithId' },

  // ---- api/v1/content/admin/warehouses: WarehouseService
  { match: /^Warehouse not found: (?<id>\S+)$/, key: 'warehouse.notFound' },

  // ---- api/v1/content/admin/book-bundles: BookBundleController, BookBundleService
  { match: /^Book bundle not found: (?<id>\S+)$/, key: 'bundle.notFound' },
  {
    match: /^Book (?<id>\S+) is listed more than once\. Set its quantity instead of repeating it\.$/,
    key: 'bundle.duplicateBook',
  },
  {
    // CycleBooksFrozenException (409): the bundle's title, then the billed periods.
    match: new RegExp(
      `^"(?<title>${ANY})" has already been charged for (?<periods>${ANY}?), so its books and price cannot change\\. Its title and description still can\\. To ship something different, create a new bundle and point the next period at it\\.$`
    ),
    key: 'bundle.booksFrozen',
  },
];

const area = { ns: 'serverBookCatalog', rules };

export default area;
